export enum SEGMENT_EVENTS {
  // in alphabetical order
  if_abandon_bill_submission = 'if_abandon_bill_submission',
  if_account_settings_updated = 'if_account_settings_updated',
  if_add_invoice_go_back_clicked = 'if_add_invoice_go_back_clicked',
  if_bill_submitted = 'if_bill_submitted',
  if_business_details_completed = 'if_business_details_completed',
  if_business_owner_removed = 'if_business_owner_removed',
  if_clicked_add_bill = 'if_clicked_add_bill',
  if_clicked_bnpl_payment_schedule_next = 'if_clicked_bnpl_payment_schedule_next',
  if_connect_revenue_account_clicked = 'if_connect_revenue_account_clicked',
  if_connect_revenue_account_dismissed = 'if_connect_revenue_account_dismissed',
  if_contract_banner_clicked = 'if_contract_banner_clicked',
  if_contract_exit = 'if_contract_exit',
  if_contract_signed = 'if_contract_signed', // used in Customer.io for sending emails to the primary user
  if_contract_signed_success = 'if_contract_signed_success',
  if_contract_task_clicked = 'if_contract_task_clicked',
  if_file_submitted_succesfully = 'if_file_submitted_succesfully',
  if_file_uploaded = 'if_file_uploaded',
  if_funding_app_add_another_invoice_clicked = 'if_funding_app_add_another_invoice_clicked',
  if_funding_app_done_clicked = 'if_funding_app_done_clicked',
  if_funding_app_submission_modal_shown = 'if_funding_app_submission_modal_shown',
  if_funding_app_whats_next_expanded = 'if_funding_app_whats_next_expanded',
  if_invited_user_onboarding_page_completed = 'if_invited_user_onboarding_page_completed',
  if_limit_reached_pdf_processing = 'if_limit_reached_pdf_processing',
  if_marketing_account_connected_success = 'if_marketing_account_connected_success',
  if_owner_profile_completed = 'if_owner_profile_completed',
  if_payment_obligations_skip = 'if_payment_obligations_skip',
  if_payment_obligations_update = 'if_payment_obligations_update',
  if_invoice_requirements_reviewed = 'if_invoice_requirements_reviewed',
  if_revenue_account_initial_onboarding_skipped = 'if_revenue_account_initial_onboarding_skipped',
  if_routed_to_manual_bank_page = 'if_routed_to_manual_bank_page',
  if_rolling_funding_comparison_wizard_closed = 'if_rolling_funding_comparison_wizard_closed',
  if_rolling_funding_comparison_wizard_opened = 'if_rolling_funding_comparison_wizard_opened',
  if_rolling_funding_clicked_compare_options = 'if_rolling_funding_clicked_compare_options',
  if_rolling_funding_clicked_continue_to_request = 'if_rolling_funding_clicked_continue_to_request',
  if_rolling_funding_inquiry_submitted = 'if_rolling_funding_inquiry_submitted',
  if_secondary_profile_added = 'if_secondary_profile_added',
  if_send_invite_cancelled = 'if_send_invite_cancelled',
  if_send_invite_clicked = 'if_send_invite_clicked',
  if_send_invite_success = 'if_send_invite_success',
  if_start_abandon_bill_submission = 'if_start_abandon_bill_submission',
  if_team_member_set_as_business_owner = 'if_team_member_set_as_business_owner',
  if_update_signatory_complete = 'if_update_signatory_complete',
  if_upload_document_clicked = 'if_upload_document_clicked',
  if_user_click_sign_CTA = 'if_user_click_sign_CTA',
  if_user_deleted = 'if_user_deleted',
  if_user_invite_modal_opened = 'if_user_invite_modal_opened',
  if_user_profile_btn_edit = 'if_user_profile_btn_edit',
  if_user_reach_full_capacity = 'if_user_reach_full_capacity',
  if_user_set_as_signatory = 'if_user_set_as_signatory',
  if_user_view_submitted_bill = 'if_user_view_submitted_bill',
  if_user_view_submitted_bill_payment_schedule = 'if_user_view_submitted_bill_payment_schedule',
  if_user_view_submitted_bill_status_timeline = 'if_user_view_submitted_bill_status_timeline',
  if_vendor_details_go_back_clicked = 'if_vendor_details_go_back_clicked',
  if_vendor_details_next_step_clicked = 'if_vendor_details_next_step_clicked',

  // Legacy events
  bnpl_waitlist_cta_clicked = 'bnpl_waitlist_cta_clicked',
  clear_pay_error = 'clear_pay_error',
  fe_account_connected = 'fe_account_connected',
  fe_accounting_account_connected = 'fe_accounting_account_connected',
  fe_accounting_account_failed_connect = 'fe_accounting_account_failed_connect',
  fe_accounting_account_modal_open = 'fe_accounting_account_modal_open',
  fe_accounting_account_modal_close = 'fe_accounting_account_modal_close',
  fe_accounting_external_conn_attempted = 'fe_accounting_external_conn_attempted',
  fe_amazon_spapi_marketplace_change_click = 'fe_amazon_spapi_marketplace_change_click',
  fe_amazon_spapi_region_picker_confirmed = 'fe_amazon_spapi_region_picker_confirmed',
  fe_amazon_spapi_region_picker_selected = 'fe_amazon_spapi_region_picker_selected',
  fe_amazon_spapi_seller_link_click = 'fe_amazon_spapi_seller_link_click',
  fe_amazon_spapi_vendor_link_click = 'fe_amazon_spapi_vendor_link_click',
  fe_anonymize_data_clicked = 'fe_anonymize_data_clicked',
  fe_anonymize_data_confirm_clicked = 'fe_anonymize_data_confirm_clicked',
  fe_bank_account_attempt = 'fe_bank_account_attempt',
  fe_bank_link_failed = 'fe_bank_link_failed',
  fe_bank_link_initiated = 'fe_bank_link_initiated',
  fe_bank_link_trouble_clicked = 'fe_bank_link_trouble_clicked',
  fe_bnpl_business_profile_completed = 'fe_bnpl_business_profile_completed',
  fe_business_owner_profiles_clicked = 'fe_business_owner_profiles_clicked',
  fe_caphome_spend_facebook_tile_click = 'fe_caphome_spend_facebook_tile_click',
  fe_change_email_clicked = 'fe_change_email_clicked',
  fe_change_password_clicked = 'fe_change_password_clicked',
  fe_clear_filter_button_clicked = 'fe_clear_filter_button_clicked',
  fe_close_clicked = 'fe_close_clicked',
  fe_delete_document = 'fe_delete-document',
  fe_docs_uploaded = 'fe_docs_uploaded',
  fe_doc_deleted = 'fe_doc_deleted',
  fe_download_link = 'fe_download-link',
  fe_product_message_clicked = 'fe_product_message_clicked',
  fe_error_banner_displayed = 'fe_error_banner_displayed',
  fe_error_banner_email_clicked = 'fe_error_banner_email_clicked',
  fe_error_banner_phone_clicked = 'fe_error_banner_phone_clicked',
  fe_extension_plan_selection_error_triggered = 'fe_extension_plan_selection_error_triggered',
  fe_filtering_button_clicked = 'fe_filtering_button_clicked',
  fe_integration_click = 'fe_integration_click',
  fe_login = 'fe_login',
  fe_logout = 'fe_logout',
  fe_marketing_account_connected = 'fe_marketing_account_connected',
  fe_marketing_account_failed_connect = 'fe_marketing_account_failed_connect',
  fe_marketing_account_modal_open = 'fe_marketing_account_modal_open',
  fe_marketing_account_modal_close = 'fe_marketing_account_modal_close',
  fe_marketing_external_conn_attempted = 'fe_marketing_external_conn_attempted',
  fe_mql_account_connected = 'fe_mql_account_connected',
  fe_my_account_collapse_clicked = 'fe_my_account_collapse_clicked',
  fe_my_account_expand_clicked = 'fe_my_account_expand_clicked',
  fe_new_archive_clicked = 'fe_new_archive_clicked',
  fe_new_archive_confirm_clicked = 'fe_new_archive_confirm_clicked',
  fe_no_platform_click = 'fe_no_platform_click',
  fe_plaid_opened = 'fe_plaid_opened',
  fe_plaid_quit = 'fe_plaid_quit',
  fe_platform_requested_name_entered = 'fe_platform_requested_name_entered',
  fe_registered_address_capture = 'fe_registered_address_capture',
  fe_sales_account_connected = 'fe_sales_account_connected',
  fe_sales_account_failed_connect = 'fe_sales_account_failed_connect',
  fe_sales_account_linked = 'fe_sales_account_linked',
  fe_sales_account_modal_open = 'fe_sales_account_modal_open',
  fe_sales_account_modal_close = 'fe_sales_account_modal_close',
  fe_sales_external_conn_attempted = 'fe_sales_external_conn_attempted',
  fe_select_bank = 'fe_select_bank',
  fe_self_serve_error = 'fe_self_serve_error',
  fe_see_more_click = 'fe_see_more_click',
  fe_selfserve_platform_requested = 'fe_selfserve_platform_requested',
  fe_sign_out_clicked = 'fe_sign_out_clicked',
  fe_sorting_button_clicked = 'fe_sorting_button_clicked',
  fe_shopify_store_connect_click = 'fe_shopify_store_connect_click',
  fe_shopify_store_entered = 'fe_shopify_store_entered',
  fe_shopify_data_collect_info_click = 'fe_shopify_data_collect_info_click',
  fe_shopify_help_centre_click = 'fe_shopify_help_centre_click',
  fe_shopify_tooltip_click = 'fe_shopify_tooltip_click',
  fe_submission_type_clicked = 'fe_submission_type_clicked',
  fe_tile_status_not_connected = 'fe_tile_status_not_connected',
  fe_toggle_language = 'fe_toggle_language',
  fe_upload_failed = 'fe_upload_failed',
  fe_upload_doc_click = 'fe_upload_doc_click',
  fe_upload_dragged = 'fe_upload_dragged',
  fe_uploaded_doc_clicked = 'fe_uploaded_doc_clicked',
  fe_upload_btn = 'fe_upload-btn',
  finish_application_cta_clicked = 'finish_application_cta_clicked',
  invoice_amount_error_displayed = 'invoice_amount_error_displayed',
  legacy_modal_cancel = 'legacy_modal_cancel',
  legacy_modal_continue = 'legacy_modal_continue',
  plaid_mandate_primary_contact_support = 'plaid_mandate_primary_contact_support',
  plaid_mandate_primary_set_intent = 'plaid_mandate_primary_set_intent',
  product_education_calculator_viewed = 'product_education_calculator_viewed',
  remove_bank_account = 'remove_bank_account',
  submit_invoice_cta_clicked = 'submit_invoice_cta_clicked',
  viewed_payments_profilepage = 'viewed_payments-profilepage',
  viewed_session_expired = 'viewed_session_expired',

  // Legacy ClearPay 1.0 Segment Events
  BE_STATUS_ERROR = 'be_status_error',
  CLEARPAY_BNPL_WAITLISTED = 'clearpay_1_0_bnpl_waitlisted',
  CLICKED_BNPL_BILL_DETAILS = 'clearpay_1_0_viewed_bnpl_bill_detail',
  CLICKED_BILL_DETAILS = 'clearpay_1_0_viewed_bill_detail',
  CLICKED_CAPACITY_EDUCATION = 'fe_capacity_education_clicked',
  CLICKED_DOWNLOAD_PAYMENT_CONFIRMATION = 'fe_download_confirmation_clicked',
  FE_DATE_ERROR = 'date_picker_error',
  FE_DATE_PICKED = 'fe_date_picked',
  FE_CHECK_TIMELINE_STATUS = 'fe_check_timeline_status',
  FOUNDER_PROVIDED_PAYMENT_DETAILS = 'clearpay_1_0_founder_provided_payment_details',
  SELECTED_REVENUE_ABOVE_10K = 'clearpay_1_0_selected_revenue_above_10k',
  SELECTED_REVENUE_BELOW_10K = 'clearpay_1_0_selected_revenue_below_10k',
  SIGNED_BNPL_CONTRACT = 'clearpay_1_0_signed_bnpl_contract', // used in Customer.io for sending emails to the primary user
  SUBMITTED_BASIC_PROFILE = 'clearpay_1_0_submitted_basic_profile',
  SUBMITTED_BUSINESS_PROFILE = 'clearpay_1_0_submitted_business_profile',
  SUBMITTED_REGISTERED_ADDRESS = 'clearpay_1_0_submitted_registered_address',
  STARTED_BILL_UPLOAD = 'clearpay_1_0_started_bill_upload',
  VIEWED_BILL_DETAILS_FORM = 'clearpay_1_0_viewed_modal_bill_details',
  VIEWED_DASHBOARD = 'clearpay_1_0_viewed_dashboard',
  VIEWED_INVOICE_MODAL_ADD_INVOICE = 'clearpay_1_0_viewed_invoice_modal_add_invoice',
  VIEWED_INVOICE_MODAL_CHOOSE_PLAN = 'clearpay_1_0_viewed_invoice_modal_choose_plan',
  VIEWED_INVOICE_MODAL_PLAN_DETAILS = 'clearpay_1_0_viewed_invoice_modal_plan_details',
  VIEWED_INVOICE_MODAL_VENDOR_DETAILS = 'clearpay_1_0_viewed_invoice_modal_vendor_details',
  VIEWED_SUBMISSION_TYPE_MODAL = 'clearpay_1_0_viewed_choose_submission_type_modal',
}
